import { Base } from '../../abstract/base.model';
import { SafetyTestFrequency } from './safety-test-frequency.model';
import { SafetyTestStatus } from './safety-test-status.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableBoolean, nullableNumber, nullableString } from '../utils/wire-value-utils';

/**
 * A safety test category with the signed-in user's status in it, built from the hub's category JSON
 * (`user-safety-test-categories-controller.ts`, hub `data-models/safety-test-category.ts`).
 * Read-only for web users, so display fields carry the hub's defaults when missing.
 */
export class SafetyTestCategory extends Base {
  name: string;
  shortName?: string;
  description?: string;
  icon: string;
  isRequired: boolean;
  frequency: SafetyTestFrequency;
  frequencyDays?: number;
  sortOrder: number;
  /** Missing for system-wide categories. */
  organizationId?: string;
  status?: SafetyTestStatus;
  expiresAt?: string;
  lastCompletedAt?: string;
  lastScore?: number;
  hasActiveTest?: boolean;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']) ?? '';
    this.shortName = nullableString(source['shortName']) ?? undefined;
    this.description = nullableString(source['description']) ?? undefined;
    this.icon = nullableString(source['icon']) ?? 'bi-clipboard-check';
    this.isRequired = nullableBoolean(source['isRequired']) ?? true;
    this.frequency = (nullableString(source['frequency']) ?? 'annual') as SafetyTestFrequency;
    this.frequencyDays = nullableNumber(source['frequencyDays']) ?? undefined;
    this.sortOrder = countOrZero(source['sortOrder']);
    this.organizationId = nullableString(source['organizationId']) ?? undefined;
    this.status = (nullableString(source['status']) ?? undefined) as SafetyTestStatus | undefined;
    this.expiresAt = nullableString(source['expiresAt']) ?? undefined;
    this.lastCompletedAt = nullableString(source['lastCompletedAt']) ?? undefined;
    this.lastScore = nullableNumber(source['lastScore']) ?? undefined;
    this.hasActiveTest = nullableBoolean(source['hasActiveTest']) ?? undefined;
  }
}
